import { ICoupon } from '../utils/entities/interface';
import { Pagination } from './booking';
import { get, post } from './https';

interface CoupenListResponse {
  status: boolean;
  data: ICoupon[];
  count: number;
  pagination: Pagination;
}
const GETCoupons = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<CoupenListResponse> => {
  // Initialize the base URL
  let url = `/api/v1/admin/coupon/list?limit=${limit}&page=${page}`;

  // Conditionally add search parameter if provided
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  // Conditionally add sortField and sortOrder if they are provided
  if (sortField && sortField !== 'name') {
    // assuming 'name' is the default field, you can change it if needed
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    // assuming 'ASC' is the default sort order
    url += `&sortOrder=${sortOrder}`;
  }

  // Fetch the response
  const response = await post(url); // Use the previously defined `get` function

  if (response.status == 200) {
    return response.data; // If status is true, return the user data
  } else {
    throw new Error('Failed to fetch users');
  }
};

interface AddEditCouponResponse {
  status: boolean;
  data: ICoupon;
  message: string;
}

const addEditCoupon = async (
  coupon: Omit<ICoupon, '_id' | 'createdAt' | 'updatedAt'> & { _id?: string },
): Promise<AddEditCouponResponse> => {
  const url = '/api/v1/admin/coupon/add-edit';

  // Create the request body
  const requestBody = {
    couponCode: coupon.couponCode,
    couponObjectid: coupon._id || '',
    image: coupon.image,
    name: coupon.name,
    discount: coupon.discount,
    minValue: coupon.minValue,
    expiryDate: coupon.expiryDate.toISOString().split('T')[0], // Ensure date format
    description: coupon.description,
    // isActive: coupon.isActive,
  };

  // Send the POST request
  const response = await post(url, requestBody);

  // Check if the response status is OK
  if (response.status === 201) {
    return response.data;
  } else {
    throw new Error('Failed to add or edit coupon');
  }
};

const ToggleCouponStatus = async (couponId: string): Promise<number> => {
  const response = await get(
    `/api/v1/admin/coupon/active-inactive/${couponId}`,
  );

  if (response.status == 200) {
    return 200;
  } else {
    throw new Error(response.statusText || 'Failed to change user status');
  }
};

export { GETCoupons, addEditCoupon, ToggleCouponStatus };
